<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="disabled"
    :parent-identifiers="parentIdentifiers"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    :permission-code="'Domain'"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './invalidFinishCombination/form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdentifiers: {
      type: Object,
      default: () => null
    },
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      columns: [
        { field: 'finish1Description', label: 'invalidFinishCombination.finish1' },
        { field: 'finish2Description', label: 'invalidFinishCombination.finish2' }
      ]
    };
  },
  methods: {
    generateSummary(row) {
      return `${row.finish1Description} - ${row.finish2Description}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
